//! Singleton instance of Content.
//! This is separated from Content.ts to break circular dependencies.
//! Many UI classes (Cursor, GridHeadings, etc.) import `content`, and Content.ts
//! imports those classes, creating a cycle. By putting the singleton in a
//! separate file, we break the cycle.

import { Content } from '@/app/gridGL/pixiApp/Content';

let _content: Content | undefined;

export const content = new Proxy({} as Content, {
  get(_target, prop, receiver) {
    if (!_content) {
      _content = new Content();
    }
    const value = Reflect.get(_content, prop, _content);
    return typeof value === 'function' ? value.bind(_content) : value;
  },
  set(_target, prop, value) {
    if (!_content) {
      _content = new Content();
    }
    return Reflect.set(_content, prop, value);
  },
});
